import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import TaskJobDetails from './TaskJobDetails';
import authService from './api-authorization/AuthorizeService';

interface JobGoAhead {
    id: number;
    jobDetails: JobDetails;
    sendEmail: boolean;
    loading: boolean;
}

interface JobDetails {
    jobId: number;
    customer: string;
    customerContact: string;
    mobile: string;
    phone: string;
    email: string;
    siteAddress: string;
    lotNumber: string;
    items: ItemList[];
}

interface ItemList {
    id: number;
    item: string;
    type: string;
    hirePeriodDays: string;
    quantityMeasure: string;
    scheduleDate: string;
}

interface INameToValueMap {
    [key: string]: any;
}

export class TaskFollowUpGoAheadData extends React.Component<RouteComponentProps<{}>, JobGoAhead> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: 0,
            jobDetails: {
                jobId: 0,
                customer: "",
                customerContact: "",
                mobile: "",
                phone: "",
                email: "",
                siteAddress: "",
                lotNumber: "",
                items: []
            },
            sendEmail: false,
            loading: true
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let jobParams: INameToValueMap = {};
        jobParams["id"] = 0;
        jobParams = this.props.match.params;
        let Id = jobParams["id"];
        this.setState({ id: Id });

        axios.get('api/User/CheckUserPermission?Permission=RunFollowUpGoAheadTask&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                //assign task to current user
                var taskdetails = {
                    Id: Id,
                    SubId: user.sub
                };
                axios.post('api/Tasks/AssignTask', taskdetails, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    //this needs to just happen in the background
                });

                axios.get('api/Tasks/GetTaskFollowUpGoAheadDetails?Id=' + Id, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ id: Id, jobDetails: res.data, loading: false });
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleCheckboxChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.checked;
        this.setState(change);
    }

    contactSubmit = (e: any) => {
        e.preventDefault();
        this.submit();
    }

    submit = () => {
        this.save();
    }

    async save() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var details = {
            taskId: this.state.id,
            jobId: this.state.jobDetails.jobId,
            sendEmail: this.state.sendEmail,
            subId: user.sub
        };

        axios.post('api/Tasks/SaveFollowUpGoAhead', details, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Task Saved");
            this.props.history.push("/tasks")
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            <h1>Follow Up Go Ahead Form</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var jobDetails = this.state.jobDetails;
        var phone = jobDetails.mobile != "" && jobDetails.phone != "" ? jobDetails.mobile + " or " + jobDetails.phone : jobDetails.mobile != "" ? jobDetails.mobile : jobDetails.phone;
        let taskJobDetails = <TaskJobDetails jobDetails={jobDetails} />

        return (
            <form name="jobDetails" onSubmit={this.contactSubmit}>
                <div>
                    <span>Please call {jobDetails.customerContact} from {jobDetails.customer} on {phone} to send through the go ahead:</span>
                    {taskJobDetails}
                    <div>
                        <div className="table__margin overflowAuto">
                            <table className="table table__large tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th>Item</th>
                                        <th>Type</th>
                                        <th>Hire Period</th>
                                        <th>Quantity</th>
                                        <th>Schedule Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobDetails.items.map((item, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{item.id}</td>
                                            <td className="table__text--align">{item.item}</td>
                                            <td className="table__text--align">{item.type}</td>
                                            <td className="table__text--align">{item.hirePeriodDays}</td>
                                            <td className="table__text--align">{item.quantityMeasure}</td>
                                            <td className="table__text--align">{item.scheduleDate}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="hidden">
                        <label className="input-group" htmlFor="sendEmail">
                            <span className="label">Send an email reminder to {this.state.jobDetails.customerContact}?</span>
                            <input className="input" type="checkbox" id="sendEmail" name="sendEmail" checked={this.state.sendEmail} onChange={(e) => this.handleCheckboxChange(e)}></input>
                        </label>
                    </div>
                    <br></br>
                    <div className="row">
                        <button className="defaultbutton-prev" type="submit">Save</button>
                    </div>
                </div>
            </form>
        );
    }
}
//class for send email once emails set up
//className={this.state.jobDetails.email == "" ? "hidden" : "" }